export default __webpack_public_path__ + "static/media/spid-idp-lepidaid.db44ecc8.svg";